/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CndnRequest } from '../../models/cndn-request';
import { CndnRequestApiRespModel } from '../../models/cndn-request-api-resp-model';

export interface ApiRequestCndnSaveSubmitPost$Params {
      body?: CndnRequest
}

export function apiRequestCndnSaveSubmitPost(http: HttpClient, rootUrl: string, params?: ApiRequestCndnSaveSubmitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CndnRequestApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiRequestCndnSaveSubmitPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CndnRequestApiRespModel>;
    })
  );
}

apiRequestCndnSaveSubmitPost.PATH = '/api/Request/Cndn/SaveSubmit';
